import en from './sign_up_form.en'
import de from './sign_up_form.de'
import fr from './sign_up_form.fr'
import it from './sign_up_form.it'
import es from './sign_up_form.es'
import ja from './sign_up_form.ja'
import ko from './sign_up_form.ko'
import ru from './sign_up_form.ru'
import zhCn from './sign_up_form.zh-CN'
import zhTw from './sign_up_form.zh-TW'

export default {
    en,
    de,
    fr,
    it,
    es,
    ja,
    ru,
    ko,
    'zh-CN': zhCn,
    'zh-TW': zhTw
};